// removed by extract-text-webpack-plugin
module.exports = {"spinner":"spinner__25X9Y","sk-bouncedelay":"sk-bouncedelay__UVljN","bounce1":"bounce1__24Od-","bounce2":"bounce2__1T0L1"};


//////////////////
// WEBPACK FOOTER
// ./components/spinner/spinner.css
// module id = kO8t
// module chunks = 446